(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxizs-modern-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ox-modern-home').forEach((section) => {
    if (section.dataset.oxReady === 'true') return;
    section.dataset.oxReady = 'true';

    const buttons = section.querySelectorAll('[data-ox-scent]');
    const figures = section.querySelectorAll('[data-ox-figure]');
    const title = section.querySelector('[data-ox-result-title]');
    const copy = section.querySelector('[data-ox-result-copy]');
    const link = section.querySelector('[data-ox-result-link]');
    const mobileTitle = section.querySelector('[data-ox-mobile-title]');
    const mobileLink = section.querySelector('[data-ox-mobile-link]');
    const mobileBar = section.querySelector('[data-ox-mobile-bar]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const scent = button.dataset.oxScent;
        buttons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        figures.forEach((figure) => {
          const active = figure.dataset.oxFigure === scent;
          figure.hidden = !active;
          figure.classList.toggle('is-active', active);
        });
        section.style.setProperty('--ox-accent', button.dataset.accent);
        if (title) title.textContent = button.dataset.title;
        if (copy) copy.textContent = button.dataset.copy;
        if (link) link.href = button.dataset.url;
        if (mobileTitle) mobileTitle.textContent = button.textContent;
        if (mobileLink) mobileLink.href = button.dataset.url;
      });
    });

    if (mobileBar) {
      const updateBar = () => {
        const bounds = section.getBoundingClientRect();
        mobileBar.classList.toggle('is-visible', bounds.top < -260 && bounds.bottom > 180);
      };
      updateBar();
      window.addEventListener('scroll', updateBar, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
